import type { TFunction } from "i18next";
import { PULSE_FIELD_LIMITS } from "@pulse/features/pulseFieldLimits";

type SurveyFormValue = {
    title: string;
    description?: string | null;
};

export function validateSurveyFields(value: SurveyFormValue, t: TFunction) {
    return {
        fields: {
            title:
                value.title.trim() === ""
                    ? t("survey.titleRequired")
                    : value.title.length > PULSE_FIELD_LIMITS.survey.title
                      ? t("survey.validation.titleMaxLength", {
                            max: PULSE_FIELD_LIMITS.survey.title,
                        })
                      : undefined,
            description:
                typeof value.description === "string" &&
                value.description.length > PULSE_FIELD_LIMITS.survey.description
                    ? t("survey.validation.descriptionMaxLength", {
                          max: PULSE_FIELD_LIMITS.survey.description,
                      })
                    : undefined,
        },
    };
}
